<template>
  <div class="p-2 component-setting-panel">

    <p>{{ component.name }}</p>

    <div>
      <component-content-manager :component="component"/>

      <component-prop-manager :component="component"/>

    </div>

    <div class="">
      <p title="A was working here and force us to use css file to make every thing">css</p>
      <textarea dir="ltr" v-model="component.css" rows="4" class="form-control"></textarea>
    </div>

    <div class="">
      <p>class</p>
      <textarea dir="ltr" v-model="component.class" rows="4" class="form-control"></textarea>

      <custom-class-handler class="my-2" :component="component"/>
    </div>

    <hr>

    <component-data-attribute-manager :component="component"/>

  </div>
</template>

<script>
import ComponentContentManager from "@/components/ComponentSettingComponents/ComponentContentManager.vue";
import ComponentPropManager from "@/components/ComponentSettingComponents/ComponentPropManager.vue";
import ComponentDataAttributeManager from "@/components/ComponentDataAttributeManager.vue";
import CustomClassHandler from "@/components/ComponentSettingComponents/CustomClassHandler/CustomClassHandler.vue";

export default {
  name: "ComponentSetting",
  components: {CustomClassHandler, ComponentDataAttributeManager, ComponentPropManager, ComponentContentManager},
  props: {
    component: {}
  },
  computed: {},

}
</script>

<style scoped>
.component-setting-panel {
  background: #3a3a3a;
  color: #eee;
  border-radius: 6px;
}

.component-setting-panel :deep(.form-control),
.component-setting-panel :deep(textarea) {
  background: #1f1f1f;
  color: #eee;
  border-color: #555;
}
</style>